var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.filter.type === _vm.GlobalFilterTypeType.SELECT
    ? _c("global-filter-select", {
        attrs: { filter: _vm.filter },
        on: { changeOption: _vm.handleOptionChange },
      })
    : _vm.filter.type === _vm.GlobalFilterTypeType.GROUPED_SELECTION
    ? _c("global-filter-select", {
        attrs: { filter: _vm.filter },
        on: { changeOption: _vm.handleOptionChange },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }